import { Component, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BusinessApiService } from '../../services/business-api.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../shared/snackbar/snackbar.component';
import { LanguageService } from '../../services/language'; 
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, MatSnackBarModule,TranslatePipe],
  selector: 'app-bachloriaregister',
  styleUrl: './bachloriaregister.component.css',
  templateUrl: './bachloriaregister.component.html',
})
export class BachloriaregisterComponent implements OnInit {
  form!: FormGroup;
  saving = signal(false);

  constructor(
    private api: BusinessApiService,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    public languageService: LanguageService
  ) {}

    toggleLanguage(): void {
    const current = this.languageService.getLanguage();

    this.languageService.changeLanguage(
      current === 'ar' ? 'en' : 'ar'
    );
  }
  
  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', Validators.required],
      studylanguage: ['', Validators.required],
      gradenumber: ['', Validators.required],
      schoolname: ['', Validators.required],
      phonenumber: ['', Validators.required],
      whatsAppnumber: ['', Validators.required],
      fatherphonenumber: ['', Validators.required],
      motherphonenumber: ['', Validators.required],
      governate: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  save(): void {
    console.log('Form value:', this.form.value);

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      Object.keys(this.form.controls).forEach((key) => {
        const c = this.form.get(key);
        if (c && c.invalid) {
          console.warn('Invalid field:', key, c.errors);
        }
      });
      this.showSuccess('يرجى تعبئة جميع الحقول المطلوبة','warning');
      //this.snack.open('يرجى تعبئة جميع الحقول المطلوبة', 'إغلاق', { duration: 3000 });
      return;
    }

    this.saving.set(true);
    const data = this.form.value;
    console.log('Data is:', data);

    this.api.createUser(data).subscribe({
      next: () => {
        this.saving.set(false);
        this.form.reset();
        // this.snack.open('تم الحفظ بنجاح', 'إغلاق', { duration: 3000 });

        this.showSuccess('تم الحفظ بنجاح','success');
        
      //   this.snack.open('تم الحفظ بنجاح', 'إغلاق', {
      //   duration: 3000,
      //   horizontalPosition: 'center',   // 'start' | 'center' | 'end' | 'left' | 'right'
      //   verticalPosition: 'bottom',     // 'top' | 'bottom'
      //   panelClass: ['custom-snackbar', 'success-snackbar'],
      //   direction: 'ltr'                 // عشان العربي
      // });

      },
      error: (e: any) => {
        this.saving.set(false);
        console.log("eeeee",e);
        this.showSuccess(e?.error?.errors?.[0] || 'حدث خطأ أثناء الحفظ','error');

        //this.snack.open(e?.error?.errors?.[0] || 'حدث خطأ أثناء الحفظ', 'إغلاق', { duration: 3000 });

      },
    });
  }


  showSuccess(message: string,type:string) {
  this.snack.openFromComponent(SnackbarComponent, {
    duration: 3000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    panelClass: ['success-snackbar'],
    data: {
      message: message,
      type: type,
      action: 'إغلاق'
    }
  });
}

}